module.exports = __webpack_public_path__ + "img/3826707.png";